import { render } from "./CloseSession.vue?vue&type=template&id=2ea49c18&scoped=true"
import script from "./CloseSession.vue?vue&type=script&lang=js"
export * from "./CloseSession.vue?vue&type=script&lang=js"

import "./CloseSession.vue?vue&type=style&index=0&id=2ea49c18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea49c18"]])

export default __exports__